module.exports = __webpack_public_path__ + "static/img/zs_c.220ca8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs_c.png
// module id = EyNu
// module chunks = 18